
























import Vue from "vue";
import { Component } from "vue-property-decorator";
import { State, Action, Getter, namespace } from "vuex-class";
import StatCard from "@/components/StatCard.vue";
import TrendChart from "@/components/TrendChart.vue";
import TimeChart from "@/components/TimeChart.vue";
import GenderRatioChart from "@/components/GenderRatioChart.vue";
import StatTableIterator from '@/components/StatTableIterator.vue';
import StatChartCard from '@/components/StatChartCard.vue';
import {
  mdiBedSingle,
  mdiAccountGroup,
  mdiCurrencyUsd,
  mdiBusAlert
} from "@mdi/js";

@Component({
  components: {
    StatCard,
    TrendChart,
    TimeChart,
    GenderRatioChart,
    StatTableIterator,
    StatChartCard
  }
})
export default class HomeView extends Vue {
  @(namespace("dashboard").Action("loadDashboard")) actionLoadDashboard: any;
  statChartItems: any = [
    {
      title: 'test',
      total: 3
    },
    {
      title: 'test',
      total: 3
    }
  ];

  created() {
    this.loadContent();
  }

  async loadContent() {
    await this.actionLoadDashboard();
  }
}
